
import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotFound extends Vue {
  private code = 404;
  private message = "La pagina che stai cercando non è disponibile.";
  private submessage = `Potrebbe essere stata spostata o cancellata, <br/>
        contattaci in caso di problemi.`;
  created(): void {
    window.location.href = "http://bracchiruote.it";
  }
}
